import { NgModule, ModuleWithProviders } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { AuthService } from './auth/auth.service';
import { AuthGuardService } from './auth-guard/auth-guard.service';
import { AuthLoadService } from './auth-load/auth-load.service';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { MenuService } from './menu/menu.service';
import { ProfileService } from './profile/profile.service';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    AuthCallbackComponent
  ],
  exports: [
    AuthCallbackComponent
  ]
})
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        AuthService,
        AuthLoadService,
        AuthGuardService,
        MenuService,
        ProfileService
      ]
    };
  }
}
